import Token from '@/utils/Token';

export default {
    parse(data) {
        return data;
    },

    option(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/upload-layout/option${params}`, Token.getHeader());
    },
}
